import login from './login';

export default {
  auth: {
    pages: {
      ...login,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/auth/index.js